"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagJM = function FlagJM(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54-122H-185.94a7.06,7.06,0,0,0-7.06,7.06V139.3a7.07,7.07,0,0,0,7.06,7.06H209.54a7.07,7.07,0,0,0,7.06-7.06V-114.94a7.06,7.06,0,0,0-7.06-7.06Zm0,0",
    transform: "translate(194 124)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-114.94a7.06,7.06,0,0,0-7.06-7.06h-31.6L11.8-13.15-154.34-122h-31.6a7.06,7.06,0,0,0-7.06,7.06v18.27L-26.86,12.18-193,121V139.3a7.06,7.06,0,0,0,7.06,7.06h31.6L11.8,37.51,177.94,146.36h31.6a7.07,7.07,0,0,0,7.06-7.06V121L50.46,12.18,216.6-96.67Zm0,0",
    transform: "translate(194 124)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M216.6-96.67V121L50.46,12.18Zm0,0",
    transform: "translate(194 124)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-193,121V-96.67L-26.86,12.18Zm0,0",
    transform: "translate(194 124)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagJM;
exports["default"] = _default;